export default {"src":"/_next/static/media/IDCC.43e0da14.svg","height":18,"width":18};